<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap">
      <b-form class="d-flex align-items-center" @submit.prevent="onSearch">
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 ml-50" type="submit">
          جستجو
        </b-button>
      </b-form>
      <div class="d-flex">
        <b-button
          class="my-1 mr-50"
          variant="outline-primary"
          :to="{ name: 'add-event' }"
        >
          ایجاد رویداد
        </b-button>
        <b-button class="my-1" variant="outline-danger" @click="removeEvents">
          حذف موارد انتخاب شده
        </b-button>
      </div>
    </div>

    <data-table :fields="fields" :items="events" :loading="loading">
      <template #selectuser="{ data }">
        <b-form-checkbox
          v-model="removeEventsData"
          :value="data.item.id"
        ></b-form-checkbox>
      </template>
      <template #id="{ data }">
        {{ data.item.id }}
      </template>
      <template #title="{ data }">
        {{ data.item.title }}
      </template>
      <template #started_at="{ data }">
        <b-badge variant="light-primary">
          {{ calcDate(data.item.started_at) }}
        </b-badge></template
      >
      <template #status="{ data }">
        {{
          data.item.status == 0
            ? "درحال ثبت نام"
            : data.item.status == 1
            ? "بسته"
            : data.item.status == 2
            ? "درحال برگزاری"
            : "پایان یافته"
        }}
      </template>
      <template #amount="{ data }"> {{ finalAmount(data.item) }} </template>
      <template #time="{ data }"> {{ data.item.time }} </template>
      <template #capacity="{ data }"> {{ data.item.capacity }} </template>

      <template #actions="{ data }">
        <div class="d-flex justify-content-around">
          <b-button
            size="sm"
            variant="flat-warning"
            :to="{
              name: 'edit-event',
              params: {
                id: data.item.id,
              },
            }"
          >
            <feather-icon icon="EditIcon" />
            <span class="ml-50">ویرایش</span>
          </b-button>

          <b-button
            size="sm"
            variant="flat-danger"
            @click="removeEvent(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">حذف</span>
          </b-button>
        </div>
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div class="col-md-3 pl-0">
        <b-form-checkbox v-model="selectAll" class="ml-2">
          انتخاب همه</b-form-checkbox
        >
      </div>
      <div class="col-md-6 d-flex justify-content-md-center align-items-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BAvatar,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BBadge,
    BPagination,
    BCard,
    BLink,
    BAvatar,
    BFormCheckbox,
    BForm,
    BFormInput,
    BFormGroup,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      selectAll: false,
      removeEventsData: [],
      events: [],
      loading: false,
      url: "/panel/events",
      currentPage: 1,
      pagination: {},
      visible: false,
      search: "",
      choosenPage: 1,
      fields: [
        { key: "selectuser", label: "" },
        { key: "id", label: "شناسه" },
        { key: "title", label: "عنوان" },
        { key: "started_at", label: "تاریخ شروع" },
        { key: "status", label: "وضعیت" },
        { key: "amount", label: "قیمت (تومان)" },
        { key: "time", label: "طول رویداد (ساعت)" },
        { key: "capacity", label: "ظرفیت" },

        { key: "actions", label: "" },
      ],
    };
  },
  watch: {
    selectAll: {
      handler(val) {
        val
          ? (this.removeEventsData = this.events.map((user) => user.id))
          : (this.removeEventsData = []);
      },
      immediate: true,
    },
    removeEventsData: {
      handler(val) {
        val.length == this.events.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    $route: {
      handler(val) {
        this.getevents();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "events",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: "events",
        });
      }
    },
  },
  created() {
    if (this.$route.query.key) {
      this.$router.push({
        name: "events",
      });
    }
  },
  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: "events",
          query: {
            key: this.search,
          },
        });
      }
    },
    finalAmount(item) {
      let finalAmount = 0;

      finalAmount = Number(item.amount) - Number(item.rebate);
      return finalAmount > 0
        ? this.decodePersianName(String(parseInt(finalAmount)))
        : "0";
    },
    removeEvent(item) {
      this.$bvModal
        .msgBoxConfirm("آیا میخواهید این مورد حذف شود ؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/events/${item.id}`);
              await this.$router.push({ name: "events", query: { page: 1 } });
              this.currentPage = await this.$route.query.page;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مورد انتخاب شده با موفقیت حذف شد.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              await this.getevents();
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "مشکلی پیش آمده است",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeEvents() {
      if (this.removeEventsData.length) {
        this.$bvModal
          .msgBoxConfirm("آیا میخواهید موارد انتخاب شده حذف شوند ؟", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "بله",
            cancelTitle: "خیر",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await new Promise((resolve, reject) => {
                  this.removeEventsData.map(async (event, index) => {
                    await this.$http.delete(`/panel/events/${event}`);
                    if (index + 1 == this.removeEventsData.length) {
                      resolve();
                    }
                  });
                });
                await this.$router.push({ name: "events", query: { page: 1 } });
                this.currentPage = await this.$route.query.page;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "موارد انتخاب شده با موفقیت حذف شدند.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
                await this.getevents();
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "مشکلی پیش آمده است",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "موردی انتخاب نشده است",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getevents() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
        });
        this.events = data.data.events;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
